var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"legalModal",attrs:{"size":"lg","centered":"","hide-footer":"","hide-header-close":"","title":_vm.title}},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9 z-depth-1-half"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"id":"iframe","src":_vm.tlink},on:{"load":_vm.load}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }